export function timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
export default function(ms, autorun = true) {
    let run;
    return fn => {
        return (run =
            run ||
            Promise.resolve(autorun ? fn() : 0)
                .then(() => timeout(ms))
                .then(() => {
                    run = false;
                    fn();
                }));
    };
}
